<div class="toolbar">
  @for (action of actions; track action.label) {
    <button
      type="button"
      class="icon-btn action-btn"
      [title]="action.label"
      [attr.aria-label]="action.ariaLabel || action.label"
      (click)="executeAction(action)">
      <span class="icon-wrapper" [innerHTML]="action.svg | safeHtml"></span>

      <span>{{ action.label }}</span>
    </button>
  }
</div>
